import React from 'react';
import { Mail } from 'lucide-react';
import { Text } from '../typography/Text';

export function ContactInfo() {
  return (
    <div className="flex items-center space-x-2">
      <Mail className="w-4 h-4 text-gray-600" />
      <Text className="text-gray-600 text-sm">
        <a href="mailto:info@hiiroo.com" className="hover:text-gray-900">
          info@hiiroo.com
        </a>
      </Text>
    </div>
  );
}